import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@mui/material';
import { Box } from '@mui/system';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Icon } from '@iconify/react';
import SelectOptionLayout, { SideItem } from '../../../../../layouts/components/SelectOptionLayout';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { useDispatch, useSelector } from 'react-redux';
import { getPaqueteriaSelectedAction } from '../../../../../redux/slices/dagpacketControlPaq';
import CardDetalle from './CardDetalle';
import {
  getDetailsStatusEmida,
  getDetailsStatusEmidaServicios
} from '../../../../../_apis_/dagpacket-recargasServicios';

export default function DialogCuentaEmida({ dataPaq = {}, idProvider = '' }) {
  const [openDialog, setOpenDialog] = useState(false);
  const dispatch = useDispatch();

  const paqSelectedData = {
    idProvider,
    dataPaq
  };

  return (
    <Box>
      {/* <IconButton
        onClick={() => {
          setOpenDialog(true);
          dispatch(getPaqueteriaSelectedAction(paqSelectedData));
        }}
        size="small"
      >
        <Icon icon="eva:more-vertical-fill" />
      </IconButton> */}
      <Button
        variant="contained"
        onClick={() => {
          setOpenDialog(true);
          dispatch(getPaqueteriaSelectedAction(paqSelectedData));
        }}
        sx={{ marginY: 2, marginLeft: 2 }}
      >
        Saldo servicios y recarga
      </Button>
      <DialogBody open={openDialog} onClose={setOpenDialog} />
    </Box>
  );
}

function DialogBody({ open, onClose }) {
  // const { name } = dataPaq;

  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      fullWidth
    >
      {/* <DialogTitle sx={{ textAlign: 'center' }} id="alert-dialog-title">
        titulo
      </DialogTitle> */}
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="h4" textAlign="center" mb={2}>
              Balance actual recargas
            </Typography>
            <CardDetalle cardFunction={getDetailsStatusEmida} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="h4" textAlign="center" mb={2}>
              Balance actual servicios
            </Typography>
            <CardDetalle cardFunction={getDetailsStatusEmidaServicios} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
